import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = {
  class: "d-flex justify-content-between bd-highlight mb-3",
  style: {"margin-top":"20px"}
}
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "标题"),
    /*#__PURE__*/_createElementVNode("th", null, "排序"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "图片"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_6 = { id: "member-list" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-row flex-align-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHomeDialog = _resolveComponent("AppHomeDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openAddAppHomeDialog('Banner')))
          }, "添加Banner"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            style: {"margin-left":"15px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openAddAppHomeDialog('栏目')))
          }, "添加栏目"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            style: {"margin-left":"15px","margin-right":"15px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openAddAppHomeDialog('分类')))
          }, "添加分类"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openAddAppHomeDialog('内容')))
          }, "添加内容")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.type), 1),
                _createElementVNode("td", null, _toDisplayString(value.title || "空"), 1),
                _createElementVNode("td", null, _toDisplayString(value.order), 1),
                _createElementVNode("td", null, _toDisplayString(value.show==0 ? '隐藏' : "显示"), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("img", {
                    class: "image-preview-list-image",
                    src: value.image
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditAppHomeDialog(value.id))
                    }, null, 8, _hoisted_9),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteAppHome(value.id, value.type))
                    }, null, 8, _hoisted_10)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_AppHomeDialog, {
      ref: "addDialogRef",
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onReopen: $setup.openEditAppHomeDialog,
      onConfirm: $setup.submitAppHome,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddDialog=false))
    }, null, 8, ["show", "item", "onReopen", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}